<template>
  <modal
    :title="
      setModel != undefined ? 'Update Destination Town' : 'Add Destination Town'
    "
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="countries == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="countries != null"
        class="floating-labels p-1rem"
        ref="form"
      >
        <formGroup
          :title="'Name'"
          v-model="model.Name"
          :errors="errors"
          :rules="{ required: true, max: 50 }"
          @keydown.enter="save"
        ></formGroup>
        <selectBox
          :title="'CountryId'"
          :as="'select'"
          :disabled="countries.length == 0"
          :buttons="true"
          v-model="model.CountryId"
          :errors="errors"
          :rules="{ required: true }"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="searchCountry"
            />
          </template>
          <template #input>
            <option :value="null"></option>
            <template v-for="item in countries" :key="item.Id">
              <option
                :value="item.Id"
                v-if="
                  item.Name.toUpperCase().indexOf(searchCountry.toUpperCase()) >
                    -1
                "
                >{{ item.Name }}</option
              >
            </template>
          </template>
          <template #buttons>
            <button
              type="button"
              @click="addCountriesOpen = true"
              class="btn waves-effect waves-light btn-success"
            >
              <i class="fas fa-plus"></i>
            </button>
          </template>
        </selectBox>
        <selectBox
          :title="'SubId'"
          :as="'select'"
          :disabled="towns.length == 0"
          v-model="model.SubId"
          :errors="errors"
        >
          <template #search>
            <input
              type="text"
              placeholder="Ara"
              class="form-control small"
              v-model="searchTown"
            />
          </template>
          <template #input>
            <option :value="null"></option>
            <template v-for="item in towns" :key="item.Id">
              <option
                :value="item.Id"
                v-if="
                  item.Name.toUpperCase().indexOf(searchTown.toUpperCase()) > -1
                "
                >{{ item.Name }}</option
              >
            </template>
          </template>
        </selectBox>
        <formGroup
          :title="'SletatId'"
          type="number"
          v-model.number="model.SletatId"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="countries == null"
        :process="process"
        >{{
          setModel != undefined
            ? "Update Destination Town"
            : "Add Destination Town"
        }}</Btn
      >
    </template>
  </modal>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Id: $event.Id, Name: $event.Name })"
  ></addCountries>
</template>

<script>
import selectBox from "@/components/formGroup/selectBox";
import addCountries from "@/views/countries/upsert";
export default {
  props: {
    setModel: Object,
    towns: Array,
  },
  components: { selectBox, addCountries },
  data() {
    return {
      model: {
        Id: null,
        SubId: null,
        CountryId: null,
        Name: null,
        SletatId: null,
      },
      process: false,
      searchTown: "",
      searchCountry: "",
      countries: null,
      addCountriesOpen: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model.Id = this.setModel.Id;
      this.model.SubId = this.setModel.SubId;
      this.model.CountryId = this.setModel.CountryId;
      this.model.Name = this.setModel.Name;
      this.model.SletatId = this.setModel.SletatId;
    }
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`DestinationTowns`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The destination town has been successfully updated."
                    : "The destination town has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
